module.exports = __webpack_public_path__ + "static/media/mine-banner-03.506d7aca.png";